import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import { Icons } from "../../atoms/Icons";
import { Col, OverlayTrigger, Popover, Row } from "react-bootstrap";
import Buttons from "../../atoms/Buttons";
import { addCommas } from "../../helpers/helpers";
import "./customAccordion.scss";
import SuccessTick from "../../assets/svg-icons/success-tick.svg";
import { RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../../redux/actions";
import { bindActionCreators } from "redux";
import LoadingSpinner from "../../atoms/Loader";
import NotFound from "../../atoms/NotFound";
const CustomAccordion = (props) => {
  const {
    chooseRetirementSteps,
    choose,
    data,
    moneyinonego,
    taxfreecash,
    moneyinchunk,
    annuitychoice,
    regularchoice,
    mixmatchchoice,
  } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );
  const { illustrationFetching, illustrationData, illustrationError } = // eslint-disable-line
    useSelector(
      (state) => state.viewIllustration // eslint-disable-line
    );
  const [iconName, setIconName] = useState("arrow-right-white");
  const dispatch = useDispatch();
  const { getIllustrationContent } = bindActionCreators(
    actionCreators,
    dispatch // eslint-disable-line
  );

  const handleMouseEnter = () => {
    setIconName("arrow-right");
  };

  const handleMouseLeave = () => {
    setIconName("arrow-right-white");
  };

  const applicationPotsSelected =
    data?.applicationPots?.length > 0
      ? data?.applicationPots
      : JSON.parse(localStorage.getItem("applicationPots"));

  const potSelectionData =
    Object.keys(choose)?.length === 0
      ? JSON.parse(localStorage.getItem("choose"))
      : choose;

  const potUsedOfTotalIndividualPotTakeAllInOneGo =
    potSelectionData?.monetaryChosenAmount /
    potSelectionData?.monetaryActualAmount;

  const potUsedOfTotalIndividualPotMoneyInChunks =
    moneyinchunk?.lumpSumAmt / potSelectionData?.monetaryChosenAmount;

  const mixMatchSelectedPercentage = mixmatchchoice?.cashLumpsum?.percentage;

  const mmTaxFree =
    mixMatchSelectedPercentage > 25
      ? (25 * potSelectionData?.monetaryChosenAmount) / 100
      : (mixMatchSelectedPercentage * potSelectionData?.monetaryChosenAmount) /
        100;

  const mmTaxable =
    mixMatchSelectedPercentage > 25
      ? ((mixMatchSelectedPercentage - 25) *
          potSelectionData?.monetaryChosenAmount) /
        100
      : 0;

  const mmTaxFreeIndividualPercentage =
    mmTaxFree / potSelectionData?.monetaryChosenAmount; //eslint-disable-line

  const mmTaxableIndividualPercentage =
    mmTaxable / potSelectionData?.monetaryChosenAmount; //eslint-disable-line

  const mmMoveToDrawdownIndividualPotPercentage =
    mixmatchchoice?.cashLumpsum?.amount /
    potSelectionData?.monetaryChosenAmount;

  const valueCorrectedAsOverlay = () => {
    return (
      <OverlayTrigger
        placement="right"
        overlay={
          <Popover id="popover-contained" className="tooltip-popover-section">
            <Popover.Body className="tooltip-popover-body">
              <p>
                All the values are estimates, based on the most accurate
                information available. They include all the contributions paid
                by you and your employer.
              </p>
              <p>
                The value of your pension savings is based on current financial
                conditions and is not guaranteed. The amounts you receive may be
                higher or lower than the amounts shown above. Payment of your
                pension will be subject to TPT’s Trust Deed and Rules, and
                regulatory requirements.
              </p>
            </Popover.Body>
          </Popover>
        }
        flip={true}
      >
        <span className="textarea-tooltip">
          <Icons iconname="tool-tip" variant="icon-twelve-px" />
        </span>
      </OverlayTrigger>
    );
  };
  const mixAndMatch =
    Object.keys(mixmatchchoice).length > 0 ? mixmatchchoice : 0; //eslint-disable-line
  const regularIncome =
    Object.keys(regularchoice).length > 0 ? regularchoice : 0; //eslint-disable-line
  const investRest = Object.keys(taxfreecash).length > 0 ? taxfreecash : 0; //eslint-disable-line
  const investRestLegacyAmt = investRest?.investTheRest?.investRestLegacyAmt
    ? investRest?.investTheRest?.investRestLegacyAmt
    : 0;
  const investRestSafetNetAmt = investRest?.investTheRest?.investRestSafetNetAmt
    ? investRest?.investTheRest?.investRestSafetNetAmt
    : 0;
  const totalIncomeTaxFreeCash =
    investRest?.investTheRest?.investRestFlexiAccessTotalValue +
    investRestLegacyAmt + //eslint-disable-line
    investRestSafetNetAmt;
  const regularChoicePercentage = regularIncome?.percentage;
  const totalIncomeMixMatch =
    mixAndMatch?.investTheRest?.annuityAmount +
    mixAndMatch?.investTheRest?.faAmount +
    mixAndMatch?.investTheRest?.faiCurrentIncome +
    mixAndMatch?.investTheRest?.miCurrentIncome +
    mixAndMatch?.cashLumpsum?.amount *
      mixAndMatch?.investTheRest?.legacyPercent +
    mixAndMatch?.cashLumpsum?.amount *
      mixAndMatch?.investTheRest?.safetynetPercent;
  const totalIncomeRegularIncome =
    regularIncome?.faAmount +
    regularIncome?.miCurrentIncome +
    regularIncome?.faiCurrentIncome; //eslint-disable-line
  const mixAndMatchInvestTheRest = mixAndMatch?.investTheRest;
  const handleIllustration = (item) => {
    const payload = {
      investorId: props.investorId,
      investorAccountId: Number(item?.potId),
      incomeFrequency: 12,
      targetTfcPercentage:
        regularIncome != 0
          ? regularChoicePercentage?.toString()
          : mixAndMatch != 0
            ? mixAndMatch?.cashLumpsum?.percentage.toString()
            : investRest != 0
              ? investRest?.percenateLumpsum?.toString()
              : "",
      // incomeAmount: totalIncomeRegularIncome.toString(),
      incomeAmount:
        regularIncome != 0 && !isNaN(totalIncomeMixMatch)
          ? totalIncomeRegularIncome?.toFixed(2)?.toString()
          : mixAndMatch != 0 && !isNaN(totalIncomeMixMatch)
            ? totalIncomeMixMatch?.toFixed(2)?.toString()
            : investRest != 0 && !isNaN(totalIncomeTaxFreeCash)
              ? totalIncomeTaxFreeCash?.toFixed(2)?.toString()
              : "0",
      pensionSavingMem: item?.potId.toString(),
      totalBalance: parseFloat(item?.potValue),
      taxFreeCash:
        regularIncome != 0
          ? item?.potMonetaryAmount * (regularChoicePercentage / 100) //eslint-disable-line
          : mixAndMatch != 0
            ? mmTaxFree
            : investRest != 0
              ? investRest.taxFreeCash
              : "",
      taxableLumpSums:
        regularIncome != 0
          ? item?.potValue -
            item?.potMonetaryAmount * //eslint-disable-line
              (regularChoicePercentage / 100) //eslint-disable-line
          : mixAndMatch != 0
            ? mmTaxable
            : investRest != 0
              ? investRest.movingToDrawDown - investRest.taxFreeCash
              : "",
      taxablePensionSavings:
        regularIncome != 0
          ? parseFloat(
              regularchoice?.riData?.movingToDrawdown.replace(/,/g, "") //eslint-disable-line
            )
          : mixAndMatch != 0
            ? mixAndMatch?.cashLumpsum?.amount
            : investRest != 0
              ? investRest.movingToDrawDown
              : "",

      requestedInvestment: [
        {
          managedIncome: {
            fundid: data?.applicationPots[0]?.managedIncomeFundId,
            fundValue:
              regularIncome != 0
                ? parseFloat(regularIncome?.miAmount)
                : mixAndMatch != 0
                  ? mixAndMatchInvestTheRest?.miCurrentIncome
                  : investRest != 0
                    ? 0
                    : "",
          },
          futureAnnuity: {
            fundid: data?.applicationPots[0]?.futureAnnuityFundId,
            fundValue:
              regularIncome != 0
                ? parseFloat(
                    regularIncome?.faIncomeAmount //eslint-disable-line
                  ) //eslint-disable-line
                : mixAndMatch != 0
                  ? parseFloat(
                      mixAndMatchInvestTheRest?.faiCurrentIncome //eslint-disable-line
                    )
                  : investRest != 0
                    ? 0
                    : "",
          },

          flexiAccess: {
            fundValue:
              regularIncome != 0
                ? parseFloat(regularIncome?.faAmount)
                : mixAndMatch != 0
                  ? parseFloat(
                      mixAndMatchInvestTheRest?.faAmount //eslint-disable-line
                    )
                  : investRest != 0
                    ? investRest?.investTheRest?.investRestFlexiAccessTotalValue
                    : "",
          },

          safetyNet: {
            fundid: data?.applicationPots[0]?.legacyFundId,
            fundValue:
              regularIncome != 0
                ? 0
                : mixAndMatch != 0
                  ? Number(
                      (
                        (parseFloat(mixAndMatch?.cashLumpsum?.amount || 0) *
                          (mixAndMatchInvestTheRest?.safetynetPercent || 0)) /
                        100
                      ).toFixed(2),
                    )
                  : investRest != 0
                    ? Number(
                        (
                          investRest?.investTheRest?.investRestSafetNetAmt || 0
                        ).toFixed(2),
                      )
                    : 0,
          },

          legacy: {
            fundid: data?.applicationPots[0]?.legacyFundId,
            fundValue:
              regularIncome != 0
                ? 0
                : mixAndMatch != 0
                  ? Number(
                      (
                        (parseFloat(mixAndMatch?.cashLumpsum?.amount || 0) *
                          (mixAndMatchInvestTheRest?.legacyPercent || 0)) /
                        100
                      ).toFixed(2),
                    )
                  : investRest != 0
                    ? Number(
                        (
                          investRest?.investTheRest?.investRestLegacyAmt || 0
                        ).toFixed(2),
                      )
                    : 0,
          },
        },
      ],
      managedIncomePaymentPerMonth:
        regularIncome != 0
          ? regularIncome?.miCurrentIncome?.toString()
          : mixAndMatch != 0
            ? mixAndMatchInvestTheRest?.miCurrentIncome.toString()
            : investRest != 0
              ? "0"
              : "",
      futureAnnuityIncomePaymentPerMonth:
        regularIncome != 0
          ? regularIncome?.faiCurrentIncome?.toString()
          : mixAndMatch != 0
            ? (
                parseFloat(
                  mixAndMatchInvestTheRest?.faiCurrentIncome //eslint-disable-line
                ) / 12
              ).toString()
            : investRest != 0
              ? "0"
              : "",
      futureFlexiAccessPaymentAmount:
        regularIncome != 0
          ? regularIncome?.faChoosenAmount?.toString()
          : mixAndMatch != 0
            ? (
                parseFloat(
                  mixAndMatchInvestTheRest?.faAmount //eslint-disable-line
                ) / 12
              ).toString()
            : investRest != 0 &&
                !isNaN(investRest?.investTheRest?.investRestFlexiAccessTotalValue) //eslint-disable-line
              ? (
                  investRest?.investTheRest?.investRestFlexiAccessTotalValue /
                  12
                ).toString()
              : "0",
      flexiAccessIncomePaymentFrequency:
        regularIncome != 0
          ? regularIncome?.faFequency?.toString()
          : mixAndMatch != 0
            ? mixAndMatchInvestTheRest?.faFequency.toString()
            : investRest != 0
              ? "Monthly"
              : "",
      totalRegularIncome:
        regularIncome != 0 && !isNaN(totalIncomeRegularIncome)
          ? totalIncomeRegularIncome?.toString()
          : mixAndMatch != 0 && !isNaN(totalIncomeMixMatch)
            ? totalIncomeMixMatch?.toString()
            : investRest != 0 && !isNaN(totalIncomeTaxFreeCash)
              ? totalIncomeTaxFreeCash.toString()
              : "0",
      retirementId: data?.retirementId ? data.retirementId : 0,
    };
    handleIllustrationClick(payload);
    props.illutrationOpened.current = true;
  };
  const handleIllustrationClick = async (payload) => {
    try {
      const result = await getIllustrationContent(payload);
      const base64String = result?.encodedPdf;

      if (!base64String) {
        alert("Document content not found.");
        return;
      }

      const byteCharacters = atob(base64String);
      const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0),
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    } catch (error) {
      console.error("Error opening document:", error);
      alert("Failed to open document.");
    }
  };

  const createContent = () => {
    switch (props.identifier) {
      case RA_STEPS_IDENTIFIERS.RETIREMENT_DATE_AND_GUIDANCE:
        return (
          <>
            <p>
              I have read important information regarding pension scams, state
              benefits, combining TPT pots and my right to shop around. <br />I
              have read the risk warnings with each pension option at{" "}
              <a
                className="tpt-links"
                href="https://tpt.co.uk/risk-warnings"
                target="_blank"
                rel="noreferrer"
              >
                tpt.co.uk/risk-warnings
              </a>
              .
            </p>
            <div className="pension-wise-guidance">
              <div className="text-key">Pension Wise guidance:</div>
              <div className="text-object">
                <ul>
                  {props?.pensionWiseGuidance.map((item, i) => {
                    return item && <li key={i}>{item}</li>;
                  })}
                </ul>
              </div>
            </div>
          </>
        );
      case RA_STEPS_IDENTIFIERS.OTHER_PENSIONS:
        return (
          <>
            <div className="selected-retirement-date flex-row">
              <div>
                The total of my tax-free lump sums is not expected to exceed the
                lump sum allowance.
              </div>
            </div>
          </>
        );

      case RA_STEPS_IDENTIFIERS.CHOOSING_YOUR_RETIREMENT:
        return (
          <>
            {chooseRetirementSteps?.isTakeMoneyInOneGo === true ? (
              <div className="all-money-in-one-go-confirm">
                <div>
                  <p className="bold-text">
                    You&apos;ve chosen to take all your money in one go
                  </p>
                </div>
                <Row>
                  {applicationPotsSelected?.map((item) => (
                    <>
                      <Row className="mb-3">
                        <Col lg={6} md={6}>
                          <Row>
                            <Col lg={6} md={6}>
                              Retiring with:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              <span>
                                {item.potId}&nbsp;&nbsp;{item.potName}
                              </span>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Your pension pot:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" + addCommas(item.potValue)}
                            </Col>
                          </Row>
                          {potUsedOfTotalIndividualPotTakeAllInOneGo * 100 !==
                            100 && (
                            <>
                              <Row>
                                <Col lg={6} md={6}>
                                  Total lump sum taken:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                        <Col>
                          <Row>
                            <Col lg={6} md={6}>
                              Of which tax-free cash(25%):
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    item.potValue *
                                    potUsedOfTotalIndividualPotTakeAllInOneGo *
                                    0.25
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Of which taxable cash:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    item.potValue *
                                    potUsedOfTotalIndividualPotTakeAllInOneGo *
                                    0.75
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <hr className="hr-complete mb-3" />
                    </>
                  ))}
                </Row>
              </div>
            ) : chooseRetirementSteps?.isTakeTaxFreeCashInvestRest === true ? (
              <div className="tax-free-cash-invest-rest">
                <div>
                  <p className="bold-text">
                    {taxfreecash?.islumpSum ? (
                      <>
                        You&apos;ve chosen to take tax-free cash and invest the
                        rest in TPT drawdown
                      </>
                    ) : (
                      <>
                        You&apos;ve chosen to take tax-free cash as an income
                        and invest the rest in TPT drawdown
                      </>
                    )}
                  </p>
                </div>
                <Row>
                  {applicationPotsSelected?.map((item) => (
                    <>
                      {" "}
                      <Row className="mb-3">
                        <Col lg={6} md={6}>
                          <Row>
                            <Col lg={6} md={6}>
                              Retiring with:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              <span>
                                {item.potId}&nbsp;&nbsp;{item.potName}
                              </span>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Your pension pot:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    item.potValue *
                                    potUsedOfTotalIndividualPotTakeAllInOneGo
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                          {taxfreecash?.islumpSum ? (
                            <>
                              <Row>
                                <Col lg={6} md={6}>
                                  Applying with:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Tax-free cash lump sum:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo *
                                        (taxfreecash?.percenateLumpsum / 100)
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Amount moved to drawdown:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        3 *
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo *
                                        (taxfreecash?.percenateLumpsum / 100)
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                            </>
                          ) : (
                            <Row>
                              <Col lg={6} md={6}>
                                Tax-free cash as income:
                              </Col>
                              <Col lg={6} md={6} className="bold-text">
                                {"£" +
                                  addCommas(
                                    (
                                      taxfreecash?.regularIncomeTaxFreeAmount *
                                      ((item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo) /
                                        potSelectionData?.monetaryChosenAmount)
                                    ).toFixed(2) //eslint-disable-line
                                  )}
                              </Col>
                            </Row>
                          )}
                        </Col>
                        <Col lg={6} md={6}>
                          {taxfreecash?.islumpSum ? (
                            <>
                              <Row>
                                {" "}
                                <span>TPT drawdown selection:</span>
                                <Col lg={6} md={6}>
                                  <ul>
                                    {taxfreecash?.investTheRest
                                      ?.investRestFlexiAccessPerc > 0 && (
                                      <li>Flexi-access</li>
                                    )}
                                    {taxfreecash?.investTheRest
                                      ?.investRestsafetyNetPer > 0 && (
                                      <li>Safety net</li>
                                    )}
                                    {taxfreecash?.investTheRest
                                      ?.investRestLegacyPerc > 0 && (
                                      <li>Legacy</li>
                                    )}
                                  </ul>
                                </Col>
                                <Col lg={6} md={6}>
                                  <ul>
                                    {taxfreecash?.investTheRest
                                      ?.investRestFlexiAccessPerc > 0 && (
                                      <li className="bold-text">
                                        {taxfreecash?.investTheRest
                                          ?.investRestFlexiAccessPerc + "%"}
                                      </li>
                                    )}
                                    {taxfreecash?.investTheRest
                                      ?.investRestsafetyNetPer > 0 && (
                                      <li className="bold-text">
                                        {taxfreecash?.investTheRest
                                          ?.investRestsafetyNetPer + "%"}
                                      </li>
                                    )}
                                    {taxfreecash?.investTheRest
                                      ?.investRestLegacyPerc > 0 && (
                                      <li className="bold-text">
                                        {taxfreecash?.investTheRest
                                          ?.investRestLegacyPerc + "%"}
                                      </li>
                                    )}
                                  </ul>
                                </Col>
                              </Row>
                            </>
                          ) : (
                            <>
                              <Row>
                                <Col lg={6} md={6}>
                                  Amount moved to drawdown per
                                  payment(flexi-access):
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        3 *
                                        (taxfreecash?.regularIncomeTaxFreeAmount *
                                          ((item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo) /
                                            potSelectionData?.monetaryChosenAmount))
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Income paid until:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {taxfreecash?.regularIncomePensionLastDate}
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                      {taxfreecash?.islumpSum && (
                        <>
                          {" "}
                          <div className="d-flex justify-content-between">
                            <div>
                              <div className="value-correct-date">
                                <span className="me-1">
                                  Values correct as of{" "}
                                  {taxfreecash?.valueCorrectAs}
                                </span>
                                {valueCorrectedAsOverlay()}
                              </div>
                            </div>
                            <a
                              className="tertiary w-auto download-btn mt-0 mb-3 me-0"
                              target="_blank"
                              rel="noreferrer"
                              onClick={() => {
                                handleIllustration(item);
                              }}
                            >
                              {item?.potId + "_Illustration.pdf"}
                            </a>
                            {illustrationFetching ? <LoadingSpinner /> : ""}
                          </div>
                          {illustrationError ? (
                            <NotFound err="Unable to load illustration" />
                          ) : (
                            ""
                          )}
                        </>
                      )}
                      <hr className="hr-complete mb-3" />
                    </>
                  ))}
                  {taxfreecash?.islumpSum && (
                    <>
                      <div>
                        <p>
                          Ensure that you’re comfortable with your choices and
                          their impact on your pension savings.
                        </p>
                        {data?.choiceCategory?.illustration?.terms && (
                          <>
                            <img
                              src={SuccessTick}
                              className="arrowIcon me-2 mb-1"
                            />
                            <span>
                              I have read and accept my illustration(s)
                            </span>
                          </>
                        )}
                      </div>
                    </>
                  )}
                </Row>
              </div>
            ) : chooseRetirementSteps?.isTakeMoneyInOneChunk === true ? (
              <div className="money-in-chunk">
                <div>
                  <p className="bold-text">
                    You&apos;ve chosen to take a lump sum withdrawal from your
                    pension pot
                  </p>
                </div>
                <Row>
                  {applicationPotsSelected?.map((item) => (
                    <>
                      <Row className="mb-3">
                        <Col lg={6} md={6}>
                          <Row>
                            <Col lg={6} md={6}>
                              Retiring with:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {" "}
                              <span>
                                {item.potId}&nbsp;&nbsp;{item.potName}
                              </span>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Your pension pot:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    item.potValue *
                                    potUsedOfTotalIndividualPotTakeAllInOneGo
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Amount withdrawn:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    item.potValue *
                                    potUsedOfTotalIndividualPotTakeAllInOneGo *
                                    potUsedOfTotalIndividualPotMoneyInChunks
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                        </Col>
                        <Col>
                          <Row>
                            <Col lg={6} md={6}>
                              Tax-free cash lump sum(25%):
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    item.potValue *
                                    potUsedOfTotalIndividualPotTakeAllInOneGo *
                                    potUsedOfTotalIndividualPotMoneyInChunks *
                                    0.25
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Taxable cash:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    item.potValue *
                                    potUsedOfTotalIndividualPotTakeAllInOneGo *
                                    potUsedOfTotalIndividualPotMoneyInChunks *
                                    0.75
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <hr className="hr-complete mb-3" />
                    </>
                  ))}
                </Row>
              </div>
            ) : chooseRetirementSteps?.isRegularHowMuchCash === true ? (
              <div className="take-regular-income mt-2">
                <p className="bold-text">
                  You’ve chosen take tax-free cash and regular income from TPT
                  drawdown
                </p>
                <Row>
                  {applicationPotsSelected?.map((item) => (
                    <>
                      <Row className="mb-3">
                        <Col lg={6} md={6}>
                          <Row>
                            <Col lg={6} md={6}>
                              Retiring with:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              <span>
                                {item.potId}&nbsp;&nbsp;{item.potName}
                              </span>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Your pension pot:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" + addCommas(item.potValue)}
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Applying with:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    item.potValue *
                                    potUsedOfTotalIndividualPotTakeAllInOneGo
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Tax-free cash lump sum:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    item.potValue *
                                    potUsedOfTotalIndividualPotTakeAllInOneGo *
                                    (regularchoice?.percentage / 100)
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                          {regularchoice?.miAllocationPercent > 0 && (
                            <>
                              <Row>
                                <Col lg={6} md={6}>
                                  Amount moved to managed income:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        (item.potValue *
                                          potUsedOfTotalIndividualPotTakeAllInOneGo -
                                          item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                                            (regularchoice?.percentage / 100)) *
                                        (regularchoice?.miAllocationPercent /
                                          100)
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Estimated managed income:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        (item.potValue *
                                          potUsedOfTotalIndividualPotTakeAllInOneGo -
                                          item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                                            (regularchoice?.percentage / 100)) *
                                        (regularchoice?.miAllocationPercent /
                                          100) *
                                        (regularchoice?.miCurrentIncome /
                                          regularchoice?.miAmount)
                                      ).toFixed(2) //eslint-disable-line
                                    )}{" "}
                                  p/m
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                        <Col>
                          {regularchoice?.faIncomePercentage > 0 && (
                            <>
                              <Row>
                                <Col lg={6} md={6}>
                                  Amount moved to future annuity income:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        (item.potValue *
                                          potUsedOfTotalIndividualPotTakeAllInOneGo -
                                          item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                                            (regularchoice?.percentage / 100)) *
                                        (regularchoice?.faIncomePercentage /
                                          100)
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Estimated future annuity income:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        (item.potValue *
                                          potUsedOfTotalIndividualPotTakeAllInOneGo -
                                          item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                                            (regularchoice?.percentage / 100)) *
                                        (regularchoice?.faIncomePercentage /
                                          100) *
                                        (regularchoice?.faiCurrentIncome /
                                          regularchoice?.faIncomeAmount)
                                      ).toFixed(2) //eslint-disable-line
                                    )}{" "}
                                  p/m
                                </Col>
                              </Row>
                            </>
                          )}
                          {regularchoice?.faPercent > 0 && (
                            <>
                              <Row>
                                <Col lg={6} md={6}>
                                  Amount moved to flexi-access
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        (item.potValue *
                                          potUsedOfTotalIndividualPotTakeAllInOneGo -
                                          item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                                            (regularchoice?.percentage / 100)) *
                                        (regularchoice?.faPercent / 100)
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Flexi-access income
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        (item.potValue *
                                          potUsedOfTotalIndividualPotTakeAllInOneGo -
                                          item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                                            (regularchoice?.percentage / 100)) *
                                        (regularchoice?.faPercent / 100) *
                                        (regularchoice?.faChoosenAmount /
                                          regularchoice?.faAmount)
                                      ).toFixed(2) //eslint-disable-line
                                    )}{" "}
                                  {regularchoice?.faFequency === "Monthly"
                                    ? "p/m"
                                    : regularchoice?.faFequency === "Quarterly"
                                      ? "p/q"
                                      : regularchoice?.faFequency ===
                                          "Half yearly"
                                        ? "p/6m"
                                        : regularchoice?.faFequency ===
                                            "Annually"
                                          ? "p/y"
                                          : ""}
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                      <div className="d-flex justify-content-between">
                        <div>
                          <div className="value-correct-date">
                            <span className="me-1">
                              Values correct as of{" "}
                              {regularchoice?.valueCorrectAs}
                            </span>
                            {valueCorrectedAsOverlay()}
                          </div>
                        </div>
                        <a
                          className="tertiary w-auto download-btn mt-0 mb-3 me-0"
                          target="_blank"
                          rel="noreferrer"
                          onClick={() => {
                            handleIllustration(item);
                          }}
                        >
                          {item?.potId + "_Illustration.pdf"}
                        </a>
                        {illustrationFetching ? <LoadingSpinner /> : ""}
                      </div>
                      {illustrationError ? (
                        <NotFound err="Unable to load illustration" />
                      ) : (
                        ""
                      )}
                      <hr className="hr-complete mb-3" />
                    </>
                  ))}
                  <div>
                    <p>
                      Ensure that you’re comfortable with your choices and their
                      impact on your pension savings.
                    </p>
                    {data?.choiceCategory?.illustration?.terms && (
                      <>
                        <img
                          src={SuccessTick}
                          className="arrowIcon me-2 mb-1"
                        />
                        <span>I have read and accept my illustration(s)</span>
                      </>
                    )}
                  </div>
                </Row>
              </div>
            ) : chooseRetirementSteps?.isAnnuityHowMuchCash === true ? (
              <div className="take-guranteed-annuity">
                <p className="bold-text">
                  You’ve chosen to take tax-free cash and buy an annuity
                </p>
                <Row>
                  {applicationPotsSelected?.map((item) => (
                    <>
                      <Row className="mb-3">
                        <Col lg={6} md={6}>
                          <Row>
                            <Col lg={6} md={6}>
                              Retiring with:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              <span>
                                {item.potId}&nbsp;&nbsp;{item.potName}
                              </span>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Your pension pot:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  item.potValue.toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Applying with:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    item.potValue *
                                    potUsedOfTotalIndividualPotTakeAllInOneGo
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                        </Col>
                        <Col>
                          <Row>
                            <Col lg={6} md={6}>
                              Taking tax free:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    item.potValue *
                                    potUsedOfTotalIndividualPotTakeAllInOneGo *
                                    (annuitychoice?.cashWithdrawPerc / 100)
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Buying an annuity with:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    item.potValue *
                                      potUsedOfTotalIndividualPotTakeAllInOneGo -
                                    item.potValue *
                                      potUsedOfTotalIndividualPotTakeAllInOneGo *
                                      (annuitychoice?.cashWithdrawPerc / 100)
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Annuity provider name
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {annuitychoice?.annuityProvider}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <hr className="hr-complete mb-3" />
                    </>
                  ))}
                </Row>
              </div>
            ) : chooseRetirementSteps?.isMixMatchHowMuchCash === true ? (
              <div className="mix-match mt-3">
                <p className="bold-text">You’ve chosen to mix and match</p>

                <Row>
                  {applicationPotsSelected?.map((item) => (
                    <>
                      <Row className="mb-3">
                        <Col lg={6} md={6}>
                          <Row>
                            <Col lg={6} md={6}>
                              Retiring with:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              <span>
                                {item.potId}&nbsp;&nbsp;{item.potName}
                              </span>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Your pension pot:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" + addCommas(item.potValue)}
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Applying with:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    item.potValue *
                                    potUsedOfTotalIndividualPotTakeAllInOneGo
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Tax-free cash lump sum:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    mmTaxFreeIndividualPercentage *
                                    (item.potValue *
                                      potUsedOfTotalIndividualPotTakeAllInOneGo)
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Amount moved to drawdown:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    item.potValue *
                                    potUsedOfTotalIndividualPotTakeAllInOneGo *
                                    mmMoveToDrawdownIndividualPotPercentage
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6} md={6}>
                              Taxable lump sum:
                            </Col>
                            <Col lg={6} md={6} className="bold-text">
                              {"£" +
                                addCommas(
                                  (
                                    mmTaxableIndividualPercentage *
                                    (item.potValue *
                                      potUsedOfTotalIndividualPotTakeAllInOneGo)
                                  ).toFixed(2) //eslint-disable-line
                                )}
                            </Col>
                          </Row>
                          {mixmatchchoice?.investTheRest?.annuityPercent >
                            0 && (
                            <>
                              <Row>
                                <Col lg={6} md={6}>
                                  Buying an annuity:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        item.potValue *
                                        potUsedOfTotalIndividualPotTakeAllInOneGo *
                                        mmMoveToDrawdownIndividualPotPercentage *
                                        (mixmatchchoice?.investTheRest
                                          ?.annuityPercent /
                                          100)
                                      ).toFixed(2) //eslint-disable-line
                                    )}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Annuity provider:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {
                                    mixmatchchoice?.investTheRest
                                      ?.annuityProvider
                                  }
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                        <Col>
                          {mixmatchchoice?.investTheRest?.miPercent > 0 && (
                            <>
                              <Row>
                                <Col lg={6} md={6}>
                                  Managed income:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {mixmatchchoice?.investTheRest?.miPercent +
                                    "%"}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Estimated income payment:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        (item.potValue *
                                          potUsedOfTotalIndividualPotTakeAllInOneGo -
                                          item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                                            (mixmatchchoice?.cashLumpsum
                                              ?.percentage /
                                              100)) *
                                        (mixmatchchoice?.investTheRest
                                          ?.miPercent /
                                          100) *
                                        (mixmatchchoice?.investTheRest
                                          ?.miCurrentIncome /
                                          mixmatchchoice?.investTheRest
                                            ?.miAmount)
                                      ).toFixed(2) //eslint-disable-line
                                    )}{" "}
                                  p/m
                                </Col>
                              </Row>{" "}
                            </>
                          )}
                          {mixmatchchoice?.investTheRest?.faiPercent > 0 && (
                            <>
                              <Row>
                                <Col lg={6} md={6}>
                                  Future annuity income:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {mixmatchchoice?.investTheRest?.faiPercent +
                                    "%"}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Estimated income payment:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        (item.potValue *
                                          potUsedOfTotalIndividualPotTakeAllInOneGo -
                                          item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                                            (mixmatchchoice?.cashLumpsum
                                              ?.percentage /
                                              100)) *
                                        (mixmatchchoice?.investTheRest
                                          ?.faiPercent /
                                          100) *
                                        (mixmatchchoice?.investTheRest
                                          ?.faiCurrentIncome /
                                          mixmatchchoice?.investTheRest
                                            ?.faiAmount)
                                      ).toFixed(2) //eslint-disable-line
                                    )}{" "}
                                  p/m
                                </Col>
                              </Row>
                            </>
                          )}
                          {mixmatchchoice?.investTheRest?.faPercent > 0 && (
                            <>
                              <Row>
                                <Col lg={6} md={6}>
                                  Flexi-access:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {mixmatchchoice?.investTheRest?.faPercent +
                                    "%"}
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={6} md={6}>
                                  Flexi-access income:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {"£" +
                                    addCommas(
                                      (
                                        (item.potValue *
                                          potUsedOfTotalIndividualPotTakeAllInOneGo -
                                          item.potValue *
                                            potUsedOfTotalIndividualPotTakeAllInOneGo *
                                            (mixmatchchoice?.cashLumpsum
                                              ?.percentage /
                                              100)) *
                                        (mixmatchchoice?.investTheRest
                                          ?.faPercent /
                                          100) *
                                        (mixmatchchoice?.investTheRest
                                          ?.faChoosenAmount /
                                          mixmatchchoice?.investTheRest
                                            ?.faAmount)
                                      ).toFixed(2) //eslint-disable-line
                                    )}{" "}
                                  {mixmatchchoice?.investTheRest?.faFequency ===
                                  "Monthly"
                                    ? "p/m"
                                    : mixmatchchoice?.investTheRest
                                          ?.faFequency === "Quarterly"
                                      ? "p/q"
                                      : mixmatchchoice?.investTheRest
                                            ?.faFequency === "Half yearly"
                                        ? "p/6m"
                                        : mixmatchchoice?.investTheRest
                                              ?.faFequency === "Annually"
                                          ? "p/y"
                                          : ""}
                                </Col>
                              </Row>
                            </>
                          )}
                          {mixmatchchoice?.investTheRest?.safetynetPercent >
                            0 && (
                            <>
                              <Row>
                                <Col lg={6} md={6}>
                                  Safety net:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {mixmatchchoice?.investTheRest
                                    ?.safetynetPercent + "%"}
                                </Col>
                              </Row>{" "}
                            </>
                          )}
                          {mixmatchchoice?.investTheRest?.legacyPercent > 0 && (
                            <>
                              <Row>
                                <Col lg={6} md={6}>
                                  Legacy:
                                </Col>
                                <Col lg={6} md={6} className="bold-text">
                                  {mixmatchchoice?.investTheRest
                                    ?.legacyPercent + "%"}
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                      <div className="d-flex justify-content-between">
                        <div>
                          <div className="value-correct-date">
                            <span className="me-1">
                              Values correct as of{" "}
                              {mixmatchchoice?.investTheRest?.valueCorrectAs}
                            </span>
                            {valueCorrectedAsOverlay()}
                          </div>
                        </div>
                        <a
                          className="tertiary w-auto download-btn mt-0 mb-3 me-0"
                          target="_blank"
                          rel="noreferrer"
                          onClick={() => {
                            handleIllustration(item);
                          }}
                        >
                          {item?.potId + "_Illustration.pdf"}
                        </a>
                        {illustrationFetching ? <LoadingSpinner /> : ""}
                      </div>
                      {illustrationError ? (
                        <NotFound err="Unable to load illustration" />
                      ) : (
                        ""
                      )}
                      <hr className="hr-complete mb-3" />
                    </>
                  ))}
                  <div>
                    <p>
                      Ensure that you’re comfortable with your choices and their
                      impact on your pension savings.
                    </p>
                    {data?.choiceCategory?.illustration?.terms && (
                      <>
                        <img
                          src={SuccessTick}
                          className="arrowIcon me-2 mb-1"
                        />
                        <span>I have read and accept my illustration(s)</span>
                      </>
                    )}
                  </div>
                </Row>
              </div>
            ) : (
              ""
            )}
            {(chooseRetirementSteps?.isTakeMoneyInOneGo ||
              chooseRetirementSteps?.isTakeMoneyInOneChunk ||
              chooseRetirementSteps?.isAnnuityHowMuchCash ||
              taxfreecash?.isRegularincome) && (
              <div className="d-flex justify-content-between">
                <div>
                  <div className="value-correct-date">
                    <span className="me-1">
                      Values correct as of{" "}
                      {chooseRetirementSteps?.isTakeMoneyInOneChunk
                        ? moneyinchunk?.valueCorrectAs
                        : chooseRetirementSteps?.isTakeMoneyInOneGo
                          ? moneyinonego?.valueCorrectAs
                          : chooseRetirementSteps?.isAnnuityHowMuchCash
                            ? annuitychoice?.valueCorrectAs
                            : chooseRetirementSteps?.isTakeTaxFreeCashInvestRest
                              ? taxfreecash?.valueCorrectAs
                              : ""}
                    </span>
                    {valueCorrectedAsOverlay()}
                  </div>
                </div>
              </div>
            )}
          </>
        );

      case RA_STEPS_IDENTIFIERS.BANK_MANDATE:
        return (
          <>
            {props.bankDetails?.swift ? (
              <Row className="d-flex justify-content-between">
                <Col md={5} lg={5}>
                  <div className="d-flex flex-row justify-content-between">
                    <div>SWIFT: </div>
                    <div className="text-object w-auto mx-2">
                      {props.bankDetails?.swift}
                    </div>
                  </div>
                  <div className="d-flex flex-row justify-content-between">
                    <div>Account name: </div>
                    <div className="text-object w-auto mx-2">
                      {props.bankDetails?.accountName}
                    </div>
                  </div>
                </Col>
                <Col md={5} lg={5}>
                  <div className="d-flex flex-row justify-content-between">
                    <div>Account Number: </div>
                    <div>{props.bankDetails?.accountNumber}</div>
                  </div>
                </Col>
              </Row>
            ) : (
              <Row className="d-flex justify-content-between">
                <Col md={5} lg={5}>
                  <div className="d-flex flex-row justify-content-between">
                    <div>Account name: </div>
                    <div className="text-object w-auto mx-2">
                      {props.bankDetails?.accountName}
                    </div>
                  </div>
                  <div className="d-flex flex-row justify-content-between">
                    <div>Sort code: </div>
                    <div className="text-object w-auto mx-2">
                      {props.bankDetails?.sortCodeVal
                        ?.match(/.{1,2}/g)
                        ?.join("-") || ""}
                    </div>
                  </div>
                </Col>
                <Col md={5} lg={5}>
                  <div className="d-flex flex-row justify-content-between">
                    <div>Account number: </div>
                    <div className="text-object w-auto mx-2">
                      {props.bankDetails?.accountNumber}
                    </div>
                  </div>
                  {props.bankDetails?.societyCode && (
                    <div className="d-flex flex-row justify-content-between">
                      <div>Building society code: </div>
                      <div className="text-object w-auto mx-2">
                        {props.bankDetails?.societyCode}
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            )}
          </>
        );
      case RA_STEPS_IDENTIFIERS.RA_IDENTITY_AND_VERIFICATION:
        return (
          <>
            <Row>
              <Col md={12}>
                <div>Thank you for providing your identity documents.</div>
              </Col>
            </Row>
          </>
        );
      case RA_STEPS_IDENTIFIERS.RA_CONFIRM_DETAILS:
        return (
          <>
            <div>
              {" "}
              <p className="title-section ">
                You&apos;ve chosen a TPT drawdown account with managed income
              </p>
            </div>
            <Row>
              <Col md={12}>
                <div>
                  The final step before submitting your retirement application.
                  Please ensure all information below is correct before
                  continuing.
                </div>
              </Col>
            </Row>
          </>
        );

      case "valueTest":
        return (
          <>
            <Row>
              <Col md={12}>{props?.yrcDescription}</Col>
            </Row>
            <Row>
              {props?.innerContent.map((item, i) => (
                <Col md={6} key={i}>
                  <h4 className="subHeading">{item?.subTitle}</h4>
                  {item?.howItWorksDescription && (
                    <p>{item?.howItWorksDescription}</p>
                  )}
                  <ul>
                    {item?.subDescription.map((desc, j) => (
                      <li key={j}>{desc}</li>
                    ))}
                  </ul>
                </Col>
              ))}
            </Row>
            <div className="btn-section">
              <Buttons
                className="primary"
                name={props.btnName}
                handleClick={(e) => {
                  e.stopPropagation();
                  props.handleButtonClick();
                }}
                variantname="icon-sixteen-px"
                iconname={iconName}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              />
            </div>
          </>
        );

      default:
        break;
    }
  };
  const handleBodyClick = (e) => {
    e.stopPropagation();
  };
  return (
    <>
      <Accordion
        className="custom-accordion"
        activeKey={props?.isOpen ? props?.eventKey : null}
        flush
      >
        <Accordion.Item
          eventKey={props?.eventKey}
          className={`accordion-border ${props?.bgColor} ${
            props?.applyShadow ? "box-shadow" : "box-shadow-complete"
          }`}
        >
          <Accordion.Header onClick={props?.handleClick}>
            <span className="icon">
              <Icons variant={props?.variant} iconname={props?.iconname} />
            </span>
            <h3 className="heading"> {props?.headertext}</h3>
            <div className="heading-nav">
              {props?.isOpen ? props?.headingNavClose : props?.headingNav}
            </div>
          </Accordion.Header>
          {props?.applyShadow ? <></> : <hr className="hr" />}
          <Accordion.Body onClick={handleBodyClick}>
            {createContent()}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};
export default CustomAccordion;
